import React, { useState, useEffect } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid } from "@material-ui/core";
import { Spinner, Card, Typography, Input, IconButton, Tooltip, Dialog, DialogHeader, DialogBody, DialogFooter, Button, Checkbox, Option, Tabs, TabsHeader, TabsBody, Tab, TabPanel, Textarea } from '@material-tailwind/react';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ExportToExcelGeneric from '../componentes/exportExcelGeneric';
import { PiePagina, Paginacion, usePaginacion } from '../Helpers/importacionesComunes'

const ICuentaBancariaUADModel = {
    id_cuenta_bancaria: null,
    id_banco: null,
    descripcion: '',
    principal: false
}


export default function CuentasBancariasUAD({ usuario }) {

    const [cuentasUadList, setCuentasUadList] = useState([])
    const [bancosList, setBancosList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [nameSearch, setNameSearch] = useState('')
    const [cuentaUadId, setCuentaUadId] = useState(0)
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [cuentasUadData, setCuentasUadData] = useState(ICuentaBancariaUADModel);
    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()

    useEffect(() => {
        obtenerArchivos()
        obtenerBancos()
    }, [])


    useEffect(() => {
        if (nameSearch.trim() === '') {
            setFilteredList(cuentasUadList);
        } 
    }, [nameSearch, cuentasUadList]);

    const handleSearchData = async () => {
        if (nameSearch.trim() === '') {
            setFilteredList(cuentasUadList);
        } else {
            const listaFiltrada = cuentasUadList.filter(item =>
                item.descripcion.toLowerCase().includes(nameSearch.toLowerCase())
            );
            setFilteredList(listaFiltrada.length > 0 ? listaFiltrada : cuentasUadList);
        }
     }


    const obtenerArchivos = async () => {
        setBuscandoDatos(true);
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/banco/cuentas`)])
            setCuentasUadList(resultList[0].data)
            setFilteredList(resultList[0].data)
            setBuscandoDatos(false);
            inicializarPaginacion(null, resultList[0].data)
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const obtenerBancos = async () => {
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/bancos`)])
            setBancosList(resultList[0].data.recordset)
        } catch (error) {
            console.log(error)
        }
    }

    const handleOpen = () => { 
        setOpen(!open);
    }

    const verItem = async (e) => {
        try {
            setCuentaUadId(e.id_cuenta_bancaria);

            let data = {
                id_cuenta_bancaria: e.id_cuenta_bancaria,
                id_banco: e.id_banco,
                descripcion: e.descripcion,
                principal: e.principal
            }
            setCuentasUadData(data)

            handleOpen();
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const verCrearItem = async (e) => {
        try {
            setCuentaUadId(0);
            handleOpen();
            setCuentasUadData(ICuentaBancariaUADModel);
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const crearAction = async () => {
        try {
            await Promise.all([Axios.post(`/api/tablasgenerales/banco/cuentas/`, cuentasUadData)])
            Swal.fire({
                icon: 'alert',
                title: `<p>La Cuenta Bancaria UAD ha sido creada con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al crear los Datos. Verifique los datos del formulario</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    const editarAction = async () => {
        try {
            await Promise.all([Axios.post(`/api/tablasgenerales/banco/cuentas`, cuentasUadData)])
            Swal.fire({
                icon: 'alert',
                title: `<p>Los datos han sido actualizados con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
            setCuentasUadData(ICuentaBancariaUADModel);
            setCuentaUadId(0);
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al actualizar los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    const borrarItem = async (e) => {
        Swal.fire({
            title: "Esta seguro que desea Eliminarlo?",
            text: "Este cambio es irreversible!",
            type: "warning",
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: "No, cancelar!",
            showCancelButton: true,
            // allowOutsideClick: false
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Promise.all([Axios.delete(`/api/tablasgenerales/banco/cuentas/${e.id_cuenta_bancaria}`)])
                        obtenerArchivos();
                        setNameSearch('');
                    } catch (error) {
                        console.log(error)
                        setBuscandoDatos(false);
                    }
                }
            }
        )
    }

    const limpiarBusqueda = async () => {
        obtenerArchivos();
        setNameSearch('')
    }

    const prepareExcelData = () => {
        return cuentasUadList.map(item => ({ Nombre: item.nombre }))
    }

    if (buscandoDatos) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando archivos...</span>
            </div>
        </Main>
    }

    if (cuentasUadList.length == 0) {
        return <Grid container justifyContent='center' alignItems='center' style={{ minHeight: '400px', textAlign: 'center' }} >
            <Grid item>
                <Typography variant="h5">
                    No se encontraron archivos
                </Typography>
            </Grid>
        </Grid>
    }

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Typography variant="h4" className="flex ">
            Cuentas Bancarias UAD
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
                <div className='w-full lg:w-96 xl:w-96 relative'>
                                <Input
                                    type="text"
                                    label="Buscar nombre de Caja UAD"
                                    value={nameSearch}
                                    onChange={(e) => { setNameSearch(e.target.value) }}
                                    color='black'
                                     />
                                <Button
                                    size="sm"
                                    color={nameSearch ? "blue" : "blue-gray"}
                                    disabled={!nameSearch}
                                    className="!absolute right-1 top-1 rounded flex"
                                    onClick={handleSearchData}
                                    >
                                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                                </Button>
                    </div>
            {cuentasUadList.length > 0 && <div className='mt-8 w-full'>
                <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                    <Button className="flex ml-2 justify-center gap-3 bg-green-500" onClick={verCrearItem}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                        Crear
                    </Button>
                <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200 ml-2' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                    <ExportToExcelGeneric data={prepareExcelData()} fileName="Listado de Cuentas Bancarias UAD" isProvider={true}/>
                </div>
                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none"
                                >
                                    Se han encontrado {cuentasUadList.length} Cuentas Bancarias UAD
                                </Typography>
                {cuentasUadList.length > 0 &&
                    <PiePagina>
                        <div className="">
                            <Paginacion configuracion={configuracion} paginar={paginar} />
                        </div>
                    </PiePagina>}
                <table className="text-left w-full mt-2">
                    <thead>
                        <tr>
                            <th
                                className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                            >
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none opacity-70"
                                >
                                    Descripción
                                </Typography>
                            </th>
                            <th
                                className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                            >
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none opacity-70"
                                >
                                    Acciones
                                </Typography>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.filter((item, index) => {
                                return index >= configuracion.iIni && index <= configuracion.iFin
                            }).map((item, index) => {
                            const isLast = index === filteredList.length - 1;
                            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                            return (
                                <tr key={index}>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {item.descripcion}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <div className="flex items-center gap-2">
                                            <Tooltip content="Ver Detalles">
                                                <IconButton variant="text" size="sm" onClick={() => verItem(item)}>
                                                    <PencilIcon className="h-4 w-4 text-gray-900" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip content="Eliminar">
                                                <IconButton variant="text" size="sm" onClick={() => borrarItem(item)}>
                                                    <TrashIcon className="h-4 w-4 text-gray-900" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {filteredList.length > 0 &&
                    <PiePagina>
                        <div className="">
                            <Paginacion configuracion={configuracion} paginar={paginar} />
                        </div>
                    </PiePagina>}
            </div>}
        </Card>
        <Dialog open={open} handler={handleOpen}>
            <DialogHeader>{cuentaUadId !== 0 ? 'Editar' : 'Crear'} Caja UAD</DialogHeader>
            <DialogBody className="xl:p-10">

                <Tabs value="Contacto" className="max-w-full mt-2">
                    <TabsBody>

                        <div className="flex flex-col w-full mt-4 select-ui-data relative z-50">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="mb-1 font-medium "
                            >
                                Bancos
                            </Typography>
                            <select
                                label="Seleccione una Región"
                                value={cuentasUadData.id_banco}
                                onChange={(e) => setCuentasUadData({...cuentasUadData, id_banco: e.target.value})}
                                className='h-10'
                            >
                                {bancosList.map((item, index) => (
                                    <option key={index} value={item.id_banco}>
                                        {item.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="flex flex-col w-full mt-4">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="mb-1 font-medium "
                            >
                                Descripción
                            </Typography>
                            <Input
                                onChange={(e) => {
                                    setCuentasUadData({...cuentasUadData, descripcion: e.target.value})
                                }}
                                value={cuentasUadData.descripcion}
                                type='text'
                                id='descripcion'
                                name='descripcion'
                                color='black'
                                className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                labelProps={{
                                    className: "before:content-none after:content-none",
                                }}
                            />
                        </div>

                        <div className="grid grid-cols-3 justify-left mt-2">
                            <Typography variant="h5" color="blue-gray" className="mt-2">
                                Cuenta Principal
                            </Typography>
                            <div className="col-span-2 flex space-x-2 w-full mt-1">
                                <Checkbox
                                    ripple={false}
                                    checked={cuentasUadData.principal} 
                                    onClick={() => setCuentasUadData({...cuentasUadData, principal: !cuentasUadData.principal})}
                                    className='w-5 h-5'
                                />
                            </div>
                        </div>
                    </TabsBody>
                </Tabs>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={() => cuentaUadId !== 0 ? editarAction() : crearAction()}
                >
                    Guardar
                </Button>
                <Button variant="text" color="blue-gray" onClick={handleOpen}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
    </div>
}

